import styled from "styled-components";
import { COLORS } from "../../../../../styles/constants.style";
export const OptionMenuWrapper = styled.div`
  .option-menu-icon {
    padding: 0px 15px;
    cursor: pointer;
    color: ${COLORS.primary_light_blue};
  }
`;
